<template>
  <mp-box>
    <mp-button :variant="variant" @click="onClickCreate">{{ title }}</mp-button>
    <modal-warn-quota :title="title" is-restricted :is-open.sync="isModalExceed" />
  </mp-box>
</template>
<script>
import ModalWarnQuota from '@/views/settings/manage-user/component/ModalWarnQuota';

export default {
  name: 'ButtonCreate',
  components: {
    ModalWarnQuota,
  },
  props: {
    variant: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isModalExceed: false,
    };
  },
  computed: {
    isQuotaRestricted() {
      return this.$store.getters.getGrantAccess?.isQuotaRestricted;
    },
  },
  methods: {
    onClickCreate() {
      if (this.isQuotaRestricted) this.isModalExceed = true;
      else if (this.to) this.$router.push({ name: this.to });
      else this.$emit('open', true);
    },
  },
};
</script>
